import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';

import { useSelector, RootState } from '../redux/store';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated } = useAuth();
  const { user } = useSelector((state: RootState) => state.user);

  let navigate = useNavigate();

  if (isAuthenticated && user) {
    if (user.attributes.roles.includes('ROLE_END_USER')) navigate(`/end-user/`);
    else navigate(`/`);
  }

  return <>{children}</>;
}
